var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddapplicationDatepicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_234_3",
    "data-name": "Component 234 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.676,
    height: 19.676,
    viewBox: "0 0 19.676 19.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55463",
    "data-name": "Path 55463",
    d: "M20.676,17.339v11.2a2.714,2.714,0,0,1-2.714,2.714H3.714A2.714,2.714,0,0,1,1,28.534v-11.2L1.339,17h19Z",
    transform: "translate(0 -10.572)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55464",
    "data-name": "Path 55464",
    d: "M20.676,8.714v1.357H1V8.714A2.714,2.714,0,0,1,3.714,6H17.962A2.714,2.714,0,0,1,20.676,8.714Z",
    transform: "translate(0 -3.304)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48197",
    "data-name": "Group 48197",
    transform: "translate(4.082 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3388",
    "data-name": "Rectangle 3388",
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "translate(-0.082)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3389",
    "data-name": "Rectangle 3389",
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "translate(5.918)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3390",
    "data-name": "Rectangle 3390",
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "translate(11.918)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddapplicationDatepicker);
export default __webpack_public_path__ + "static/media/addapplication-datepicker.050feb5932f9206ac88290cff70cded9.svg";
export { ForwardRef as ReactComponent };